import { EmotionLevel } from '@/components/EmotionSelector';

export const getEmotionColor = (emotion: EmotionLevel) => {
  switch (emotion) {
    case -2: return "bg-red-500 text-white shadow-red-300/50";      // Frustrated
    case -1: return "bg-orange-400 text-white shadow-orange-300/50";   // Sad
    case 0: return "bg-slate-400 text-white shadow-slate-300/50";      // Neutral
    case 1: return "bg-blue-400 text-white shadow-blue-300/50";      // Happy
    case 2: return "bg-green-500 text-white shadow-green-300/50";     // Wow
    default: return "bg-slate-400 text-white shadow-slate-300/50";
  }
};

export const getEmotionIcon = (emotion: EmotionLevel) => {
  switch (emotion) {
    case -2: return "😠"; // Frustrated
    case -1: return "😟"; // Sad 
    case 0: return "😐";  // Neutral
    case 1: return "😊";  // Happy
    case 2: return "😍";  // Wow
    default: return "😐";
  }
};

export const getEmotionName = (emotion: EmotionLevel) => {
  switch (emotion) {
    case -2: return "Frustrated";
    case -1: return "Sad";
    case 0: return "Neutral";
    case 1: return "Happy";
    case 2: return "Wow";
    default: return "Neutral";
  }
};

export const getEmotionPosition = (emotion: EmotionLevel) => {
  switch (emotion) {
    case -2: return "top-[80%]";   // Frustrated (bottom)
    case -1: return "top-[60%]";   // Sad
    case 0: return "top-[40%]";    // Neutral (middle)
    case 1: return "top-[20%]";    // Happy
    case 2: return "top-0";        // Wow (top) - 0% from top
    default: return "top-[40%]";   // Default to middle
  }
};

export const getEmotionPercentage = (emotion: EmotionLevel): number => {
  switch (emotion) {
    case -2: return 80;   // Frustrated (bottom)
    case -1: return 60;   // Sad
    case 0: return 40;    // Neutral (middle)
    case 1: return 20;    // Happy
    case 2: return 0;     // Wow (top)
    default: return 40;   // Default to middle
  }
};
